import { Users } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function NewPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Users", href: "/users" },
          { title: "Create User", href: `/users/new` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Create User</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Users.New />
        </div>
      </div>
    </div>
  );
}
